import Vue from 'vue'
import elSelectLoadmore from './el-select-loadmore'
import scrollLoadNew from './scroll-load'
import drawerClose from './drawer-close'
import dialogClose from './dialog-close'

Vue.directive('el-select-loadmore', elSelectLoadmore)
Vue.directive('scroll-load', scrollLoadNew)
Vue.directive('drawer-close', drawerClose)
Vue.directive('dialog-close', dialogClose)
